
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Informações Gerais',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'number',
        field: 'ordem',
        label: 'Ordem',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10',
        type: 'text',
        field: 'nome',
        label: 'Nome',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_campo',
        tipo: 207,
        label: 'Tipo de Campo',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_vinculo',
        clearable: true,
        tipo: 218,
        label: 'Vínculo com Fator de Risco',
        info: 'Aqui você pode relacionar esse campo com os campos dos Fatores de Riscos. Esse vínculo vai automatizar o cadastro dos fatores de riscos no LTCAT.',
        rules: ['required']
    },
    // {
    //     class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    //     type: 'select-custom',
    //     field: 'id_cat',
    //     label: 'Categoria',
    //     clearable:true,
    //     option: {
    //         key: 'id',
    //         label: 'nome',
    //         value: 'id'
    //     },
    //     info: '',
    //     rules: ['']
    // },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'unidade',
        label: 'Unidade de Medida',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'mascara',
        label: 'Máscara',
        info:'Utilize esse campo para formatar o conteúdo do campo. Exemplo: Telefone: (99) 9999-9999 ou CPF: 999.999.999-99',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'valor_ref_min',
        label: 'Valor de Referência (mínimo)',
        mask:'money',
        info:'Utlize esse campo se quiser aplicar um valor de refrência para o campo. Esse valor pode ser utilizado para comparação se o valor de lançamento está dentro dos parâmetros definidos nas normas.',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'valor_ref_max',
        label: 'Valor de Refrência (máximo)',
        mask: 'money',
        info: 'Utlize esse campo se quiser aplicar um valor de refrência para o campo. Esse valor pode ser utilizado para comparação se o valor de lançamento está dentro dos parâmetros definidos nas normas.',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'boolean',
        field: 'ativo',
        label: 'Registro Ativo?',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'boolean',
        field: 'obrigatorio',
        label: 'Preenchimento Obrigatório?',
        info:'Se habilitar esse campo, o mesmo deverá ser preenchido obrigatoriamente no momento do cadastro do LTCAT',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
        type: 'boolean',
        field: 'ordenar',
        label: 'Ordenar as colunas a partir daqui',
        info:'Habilite essa opção se quiser ordenar as colunas a partir desse item. Isso funciona caso precisar incluir uma coluna entre várias outras.',
        rules: ['']
    }
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/tabela-dinamica/_form/tabela-coluna-cadastrar.js